var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"1170px","margin":"0 auto"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }